import React from 'react';
import { Icon } from '@design-system/index';
import './Checkbox.scss';
import { Checkmark } from '@icons';

export type CheckboxProps = {
    checked: boolean;
    onChange: (checked: boolean) => void;
    children?: React.ReactNode
};

export const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange, children }) => {
    return (
        <div className="checkbox-content">
            <label className="checkbox-wrapper">
                <input type="checkbox" className="row-checkbox" checked={checked} onChange={() => onChange(!checked)} />
                <span className="checkmark">
                    <Icon icon={<Checkmark />} color="primary" size={12} className="checkmark-icon"/>
                </span>
                {children && <span className="checkbox-label">{children}</span>}
            </label>

        </div>
    );
};
